var exports = {
  "wx": "GuildHeaderBottomSheet.module__header___NW9JS3",
  "R3": "GuildHeaderBottomSheet.module__avatarWrapper___NW9JS3",
  "Kk": "GuildHeaderBottomSheet.module__icon___NW9JS3",
  "Qq": "GuildHeaderBottomSheet.module__text___NW9JS3",
  "DD": "GuildHeaderBottomSheet.module__title___NW9JS3",
  "M1": "GuildHeaderBottomSheet.module__stats___NW9JS3",
  "dJ": "GuildHeaderBottomSheet.module__stat___NW9JS3",
  "gW": "GuildHeaderBottomSheet.module__statDot___NW9JS3",
  "rR": "GuildHeaderBottomSheet.module__statDotOnline___NW9JS3",
  "rb": "GuildHeaderBottomSheet.module__statDotMembers___NW9JS3",
  "KA": "GuildHeaderBottomSheet.module__statText___NW9JS3",
};

module.exports = exports;
